import apisauce from "apisauce";

export const USER_API = process.env.REACT_APP_USER_API || "develop"
export const PASSWORD_API = process.env.REACT_APP_PASSWORD_API || "UHJ1ZWJhczEyMw=="

const create = (endpoint = process.env.REACT_APP_API) => {
  const api = apisauce.create({
    baseURL: endpoint,
    timeout: 122000,
    headers : {
      'user-api': USER_API,
      'password-api': PASSWORD_API,
    }
  });

  const post = (endpoint, data, options = {}) => api.post(endpoint, data, options);
  const get = (endpoint) => api.get(endpoint);
  const put = (endpoint, data) => api.put(endpoint, data);
  const remove = (endpoint, data) => api.delete(endpoint, data);
  const deleteWithBody = (endpoint, data) => api.delete(endpoint, {}, { data });

  const setToken = async () => {
    try {
      const sesion = JSON.parse(localStorage.getItem('sesion-mireclu'));
      if (!sesion) return;
      api.setHeader("Authorization", "Bearer " + sesion.jwt);
    } catch (error) {
      console.error(error);
    }
  };

  const setHeaderFormFiles = () =>
    api.setHeader("Content-Type", "Multipart/form-data");

  return {
    post,
    get,
    put,
    remove,
    setToken,
    setHeaderFormFiles,
    deleteWithBody,
  };
};

const api = create();

export default api;
